<template>
  <form>
    <ModalEdition :isEdition="params.id != null" :modalId="'modalEditIdentite'" ref="modalIdentiteRef"
      :dialogClass="'modal-dialog modal-lg'" @save="saveIdentite">
      <div class="form">
        <div class="row align-items-center mb-3">
          <div class="col-md-3 d-flex align-items-center">
            <label for="client_societe" class="mb-0">Nom de la Société :</label>
          </div>
          <div class="col-md-5">
            <input type="text" class="form-control" id="client_societe" v-model="client.societe" />
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-3 d-flex align-items-center">
            <label for="client_nom" class="mb-0">Nom :</label>
          </div>
          <div class="col-md-5">
            <input type="text" class="form-control" id="client_nom" v-model="client.nom" />
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-3 d-flex align-items-center">
            <label for="client_prenom" class="mb-0">Prénom :</label>
          </div>
          <div class="col-md-5">
            <input type="text" class="form-control" id="client_prenom" v-model="client.prenom" />
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-3 d-flex align-items-center">
            <label for="client_tva" class="mb-0">TVA :</label>
          </div>
          <div class="col-md-5">
            <input type="text" class="form-control" id="client_tva" v-model="client.tva" />
          </div>
        </div>

        <div class="form-group row">
          <label for="sexe" class="col-md-3 col-form-label">Sexe :</label>
          <div class="col-md-3">
            <select id="sexe" v-model="client.sexe" class="form-control">
              <option value="F">Madame</option>
              <option value="M">Monsieur</option>
              <option value="X">Autre</option>
            </select>
          </div>
        </div>

        <div>
          <label class="mb-2 fw-bold">Adresse :</label>

          <div class="row mb-3 ">
            <div class="col-md-3 text-end">
              <label for="client_adresse_rue" class="col-form-label">Rue :</label>
            </div>
            <div class="col-md-9">
              <input type="text" class="form-control" id="client_adresse_rue" v-model="client.adresse.rue" />
            </div>
          </div>

          <div class="row mb-3 ">
            <div class="col-md-3 text-end">
              <label for="client_adresse_numero" class="col-form-label">Numéro :</label>
            </div>
            <div class="col-md-4">
              <input type="text" class="form-control" id="client_adresse_numero" v-model="client.adresse.numero" />
            </div>
          </div>

          <div class="row mb-3 ">
            <div class="col-md-3 text-end">
              <label for="client_adresse_codePostal" class="col-form-label">Code postal :</label>
            </div>
            <div class="col-md-4">
              <input type="text" class="form-control" id="client_adresse_codePostal"
                v-model="client.adresse.codePostal" />
            </div>
          </div>

          <div class="row mb-3 ">
            <div class="col-md-3 text-end">
              <label for="client_adresse_localite" class="col-form-label">Localité :</label>
            </div>
            <div class="col-md-4">
              <input type="text" class="form-control" id="client_adresse_localite" v-model="client.adresse.localite" />
            </div>
          </div>
        </div>

        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th colspan="4">Coordonées:</th>
            </tr>
            <tr>
              <th class="col-sm-2">Type</th>
              <th class="col-sm-9">Info</th>
              <th class="col-sm-1"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(coordonnee, index) in client.coordonnee">
              <td>{{ coordonnee.typeCoordonnee }}</td>
              <td>{{ coordonnee.information }}</td>
              <td>
                <a v-on:click="editCoordonnee(index)">
                  <i class="material-icons" style="font-size:20px;color:black">edit</i>
                </a>
                <a v-on:click="deleteCoordonnee(index)">
                  <i class="material-icons" style="font-size:20px;color:red">delete</i>
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <select class="form-control" v-model="inputType" ref="modif">
                  <option disabled selected></option>
                  <option value="FIXE">Fixe</option>
                  <option value="GSM">GSM</option>
                  <option value="EMAIL">Email</option>
                </select>
              </td>
              <td><input type="text" class="form-control" v-model="inputInfo"></td>
              <td>
                <button class="btn btn-primary" :disabled="!inputType || !inputInfo"
                  @click="ajouterCoordonnee()">Ajouter</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ModalEdition>
  </form>

</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
  name: 'IdentiteEdit',
  components: {
    ModalEdition
  },
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({}),
    },

  },
  data() {
    return {
      client: {
        adresse: {
          rue: '',
          numero: '',
          codePostal: '',
          localite: ''
        },
        coordonnee: []
      },

      inputType: '',
      inputInfo: '',
      errors: [],
    }
  },
  methods: {
    getIdentite(id) {
      Axios.get('/identite/' + id).then(res => {
        this.client = res.data;
      }).catch(err => {
        console.error('Erreur lors du chargement de l identité :', err);
      });
    },
    saveIdentite() {
      this.errors = [];
      if (this.errors.length) {
        this.$refs.modalIdentiteRef.errorMessage(this.errors)
        return;
      }

      Axios.post('/identite', this.client)
        .then(() => {
          this.$refs.modalIdentiteRef.closeModal();
          this.$emit('saved');
        }).catch(err => {
          console.error('Erreur lors de la sauvegarde de l identité:', err);
        });
    },
    ajouterCoordonnee() {

      const newCoordonnee = {
        typeCoordonnee: this.inputType,
        information: this.inputInfo
      };

      if (this.editIndex !== null && this.editIndex >= 0) {
        this.client.coordonnee.splice(this.editIndex, 1, newCoordonnee);
      } else {
        this.client.coordonnee.push(newCoordonnee);
      }

      this.inputType = '';
      this.inputInfo = '';
      this.editIndex = null;
    },
    editCoordonnee(index) {
      this.inputType = this.client.coordonnee[index].typeCoordonnee;
      this.inputInfo = this.client.coordonnee[index].information;
      this.editIndex = index;
      this.$nextTick(() => {
        this.$refs.modif.focus();
      });
    },
    deleteCoordonnee: function (index) {
      this.client.coordonnee.splice(index, 1);
    },
  },
  watch: {
    params: {
      handler(params) {
        if (params.id != null) {
          this.getIdentite(params.id);
        }
      },
      deep: true,
    },
  },
}
</script>

<style>
.form {
  max-width: 300px;
  margin: 0 auto;
}

.formGroup {
  max-width: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
</style>